module.exports = __webpack_public_path__ + "static/img/xs1-1.ca410f1.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/layout/xs1-1.png
// module id = 793
// module chunks = 0